import type { TourEvent } from '@/features/events';
import { formatDateRangeLong } from '@/features/events';
import { Section } from '@/components/layout';
import { ResponsiveImage } from '@/components/media';
import { TicketCta } from '@/components/ui';
import { Reveal } from '@/components/motion';
import { mexicoMedia } from '../media';
import { MEXICO_COPY } from '../copy';
import { ArrowRule } from '../ornaments/ArrowRule';
import { SunBurst } from '../ornaments/SunBurst';
import styles from './EntradasMexico.module.css';

const TITLE_ID = 'mexico-entradas';

export interface EntradasMexicoProps {
  event: TourEvent;
}

/**
 * S5 · ENTRADAS — banda y 1383-1536 del mockup. Cierre centrado sobre crema con
 * ornamento vegetal dorado a ambos márgenes.
 *
 * El CTA lo resuelve `TicketCta` con el `salesState` del dato: hoy `coming-soon`
 * y por tanto un botón `aria-disabled` con su estado leído en voz alta. Ni un
 * `href="#"`, ni un enlace a la home de la plataforma (ADR-003 §3).
 */
export function EntradasMexico({ event }: EntradasMexicoProps) {
  return (
    <Section
      background="surface"
      spacing="tight"
      labelledBy={TITLE_ID}
      className={styles.section}
      ornament={
        <ResponsiveImage
          asset={mexicoMedia.leafFrame}
          sizes="100vw"
          className={styles.leaves}
          decorative
        />
      }
    >
      <Reveal className={styles.body}>
        <h2 id={TITLE_ID} className={styles.title}>
          <ArrowRule className={styles.arrow} />
          <span>{MEXICO_COPY.entradas.eyebrow}</span>
          <ArrowRule direction="left" className={styles.arrow} />
        </h2>

        <p className={styles.lead}>
          {formatDateRangeLong(event)}, en {event.city}. Nos vemos allí.
        </p>

        <div className={styles.ctaRow}>
          <TicketCta event={event} variant="standard" size="lg" />
        </div>

        <p className={styles.nota}>Compra en la tienda oficial de la gira.</p>

        <p className={styles.close}>
          <span className={styles.rule} />
          <SunBurst size={24} />
          <span className={styles.rule} />
        </p>
      </Reveal>
    </Section>
  );
}
